<ul *ngIf="watchlists?.length > 0"
    class="watchlists">
  <li *ngFor="let watchlist of sortedWatchlists;
              trackBy:identifyWatchlist;"
      class="watchlists__entry">
    <a class="watchlists__entry__inner watchlists__entry__inner--list"
       [routerLink]="[detailPageLinkPrefix, watchlist.uuid]"
       [target]="openDetailInNewTab ? '_blank' : '_self'"
       [title]="watchlist?.name.length > 20 ? watchlist.name : ''">
      <span class="watchlists__entry__date">
        {{ watchlist.lastModified | p1DateFormat }}
      </span>
      <span class="watchlists__entry__title">
        {{ watchlist.name }}
      </span>
      <span *ngIf="watchlist.comment"
            class="watchlists__entry__comment">
          <i class="icon"><p1-lib-icons-icon-wrapper name="iconComment"></p1-lib-icons-icon-wrapper></i>
          {{watchlist.comment}}
      </span>
      <p1-watchlist-preview [watchlist]="watchlist"
                            [maxPreviewCount]="maxPreviewCount">
      </p1-watchlist-preview>
    </a>
    <ul class="watchlists__entry__cta-area">
      <li *ngIf="canEdit">
        <button p1Button
                buttonType="link-style-secondary"
                (click)="editWatchlist.emit(watchlist)"
                data-gtm-event-category="WatchList"
                [attr.data-gtm-event-action]="'Open update watchlist dialog - uuid ' + watchlist?.uuid"
                data-gtm-event-label="Watchlist list page - Update watchlist - Button"
                title="Edit watchlist"
                i18n-title="title for edit watchlist icon on watchlists list // page: watchlists list @@watchlists-list.component_title-edit-watchlist">
          <i class="icon">
            <p1-lib-icons-icon-wrapper name="iconEdit"></p1-lib-icons-icon-wrapper>
          </i>
        </button>
      </li>
      <li *ngIf="canRemove">
        <button p1Button
                buttonType="link-style-secondary"
                (click)="removeWatchlist.emit(watchlist)"
                title="Remove"
                i18n-title="title for remove icon on watchlists list // page: watchlists list @@watchlists-list.component_title-remove">
          <i class="icon">
            <p1-lib-icons-icon-wrapper name="iconBin"></p1-lib-icons-icon-wrapper>
          </i>
        </button>
      </li>
      <li *ngIf="canShare">
        <button p1Button
                buttonType="link-style-secondary"
                (click)="shareWatchlist.emit(watchlist)"
                title="Share"
                i18n-title="title for share icon on watchlists list// page: watchlists list @@watchlists-list.component_title-share">
          <i class="icon">
            <p1-lib-icons-icon-wrapper name="iconShare"></p1-lib-icons-icon-wrapper>
          </i>
        </button>
      </li>
    </ul>
  </li>
</ul>
